module.exports = __webpack_public_path__ + "81b86e4c6bea4ff752b189182c346c15.svg";